module.exports = __webpack_public_path__ + "img/hierarchy.9be22abf.svg";